/* Shared cart-offer presentation. Cart writes stay inside GRIGCart. */
(function (win) {
  'use strict';
  var doc = win.document, node = doc.getElementById('grigOfferConfig'), config;
  if (!node || !win.GRIGOfferEngine || !win.GRIGMerch) return;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  var engine = win.GRIGOfferEngine, strings = config.strings || {}, state = null, settledState = null, cart = null, catalog = null;
  var scenario = 'regular', revision = 0, localBusy = false, pending = new WeakMap(), banner, dialog, returnFocus;
  var slots = Array.from(doc.querySelectorAll('[data-grig-offer]'));
  // The engine's shared offer-mode predicate decides preview, native or plain.
  function mode() { return engine.offerMode(config, win.Shopify && win.Shopify.theme); }
  function authorized() { return mode() === 'preview'; }
  function nativeConfig() {
    if (mode() !== 'native') return null;
    var native = config.native;
    if (native.sachets && native.sachets.enabled === false) native = Object.assign({}, native, {sachets:null});
    return native;
  }
  function text(key, values) {
    var value = strings[key] || '';
    Object.keys(values || {}).forEach(function (k) { value = value.replaceAll('{' + k + '}', String(values[k])); });
    return win.grigDecode ? win.grigDecode(value) : value;
  }
  // Thresholds and gaps read better without zero cents: "49 €", not "49,00 €".
  function money(value, short) {
    var whole = short === true && value % 100 === 0;
    return new Intl.NumberFormat(config.locale, {style:'currency',currency:cart && cart.currency || config.currency,
      minimumFractionDigits:whole || config.currency === 'CZK' ? 0 : 2,maximumFractionDigits:whole ? 0 : 2}).format(value / 100);
  }
  function el(tag, cls, value) { var n = doc.createElement(tag); if (cls) n.className = cls; if (value != null) n.textContent = value; return n; }
  function policy() {
    var result = {preview:{authorized:authorized()},regular:{enabled:true,threshold:5,percent:10,currencies:['EUR','CZK']},
      bf:{enabled:true,currency:'EUR',threshold:10001,basePercent:20,bonusPercent:30,
        startsAt:'2026-11-20T00:00:00+01:00',endsAt:'2026-11-28T00:00:00+01:00'},shipping:{},nativeCampaign:win.GRIG_CAMPAIGN};
    var currency = cart && cart.currency || config.currency, country = String(config.country || '').toUpperCase();
    var native = nativeConfig();
    if (native) {
      // Native rules come from theme settings; free shipping needs an explicit
      // per-country amount and, on the isolated dev store, its verified flag.
      result.native = {enabled:true, sachets:Object.assign({enabled:true}, native.sachets), bf:native.bf,
        combinableCodes:Array.isArray(native.combinableCodes) ? native.combinableCodes : []};
      // The per-country amount is in the shop currency; another cart currency gets no claim.
      var gated = win.GRIG_DEV_POLICY && win.GRIG_DEV_POLICY.shippingVerified !== true;
      if (!gated && Number.isSafeInteger(native.shipping) && native.shipping > 0 && ['EUR','CZK'].includes(currency) &&
          native.shippingCurrency === currency) {
        // The live store grants free shipping from the cart before discounts (GRIG build checkout
        // function); shippingCodes lists the codes that combine with it.
        result.shipping[currency] = {threshold:native.shipping, verified:true, beforeDiscounts:native.shippingBeforeDiscounts === true,
          codes:Array.isArray(native.shippingCodes) ? native.shippingCodes : []};
      }
      return result;
    }
    if (authorized() && currency === 'EUR' && ['DE','AT','BE','FR'].includes(country)) result.shipping.EUR = {threshold:4900,planned:true};
    else if (authorized() && currency === 'CZK' && country === 'CZ') result.shipping.CZK = {threshold:99000,verified:true};
    else if (Number.isSafeInteger(win.GRIG_FREE_SHIPPING) && win.GRIG_FREE_SHIPPING > 0 &&
      String(win.GRIG_COUNTRY) === country && win.GRIG_CURRENCY === currency && ['EUR','CZK'].includes(currency)) {
      result.shipping[currency] = {threshold:win.GRIG_FREE_SHIPPING,verified:true};
    }
    return result;
  }
  // Shopify's clock as the cart reads tell it (GRIGCart.now), else the client's: every Black
  // Friday decision (the quote, a projection, the boundary) follows Shopify's period.
  function now() { return win.GRIGCart && typeof win.GRIGCart.now === 'function' ? win.GRIGCart.now() : Date.now(); }
  // Without GRIGCart only the client clock exists; with it, Shopify's is known once a read answered.
  function clockKnown() { return !win.GRIGCart || win.GRIGCart.clockSampled !== false; }
  function quote(value, data) {
    return engine.compute(value, data || catalog, policy(), {mode:authorized() ? 'preview' : 'native',
      themeId:config.themeId,themeRole:config.themeRole,scenario:scenario,
      now:authorized() && scenario === 'bf' ? Date.parse('2026-11-23T12:00:00+01:00') : now()});
  }
  async function getCatalog(force) { return win.GRIGMerch.catalog(force === true); }
  // The merchandising loader's freshness rule (30 s from its loadedAt stamp) decides
  // whether a held catalog may still quote anything.
  var fresh = win.GRIGMerch.fresh;
  // A held catalog may re-quote a new cart only while fresh and only when it resolves
  // every line of that cart.
  function catalogCovers(data, value) {
    return fresh(data) && !!data.variants && value.items.every(function (line) {
      var variant = line && data.variants[String(line.variant_id == null ? line.id : line.variant_id)];
      return !!(variant && variant.product);
    });
  }
  function projectionFor(items) {
    if (!state || !cart || !catalog || !Array.isArray(items)) return null;
    var modeled = cart;
    for (var i = 0; i < items.length; i++) {
      var row = items[i], variant = row && catalog.variants[String(row.id)];
      if (!variant || !Number.isSafeInteger(row.quantity) || row.quantity <= 0) return null;
      modeled = engine.projectAdding(modeled, variant, row.quantity);
      if (!modeled) return null;
    }
    return quote(modeled, catalog);
  }
  function textNode(title, kind) {
    var box = el('div','gaov-goal gaov-goal--text'), heading = el('p','gaov-heading',title);
    box.dataset.offerGoal = kind; box.append(heading); return box;
  }
  function goalNode(goal, title, note) {
    var box = el('div','gaov-goal'), heading = el('p','gaov-heading',title), track = el('div','gaov-track');
    track.setAttribute('role','progressbar'); track.setAttribute('aria-label',title);
    track.setAttribute('aria-valuemin','0');track.setAttribute('aria-valuemax',String(goal.target));
    track.setAttribute('aria-valuenow',String(Math.min(goal.current,goal.target)));track.setAttribute('aria-valuetext',title);
    var fill = el('span');fill.style.setProperty('--aov-progress',String(Math.round(goal.progress * 10000) / 100) + '%');
    track.append(fill);box.append(heading,track);if (note) box.append(el('p','gaov-note',note));return box;
  }
  function totals(result) {
    var box = el('div','gaov-totals');
    function row(label, value, cls) { var n=el('div',cls);n.append(el('span','',label),el('strong','',money(value)));box.append(n); }
    if (cart && Number.isSafeInteger(cart.total_price)) row(text('native_total'),cart.total_price);
    if (result && result.projection.active) {
      row(text('preview_total'),result.projection.total,'gaov-price');row(text('preview_saving'),result.projection.savings);
    } else box.append(el('p','gaov-note',text(result && result.projection.status === 'unsupported-currency' ? 'bf_unavailable' : 'unavailable')));
    box.append(el('p','gaov-note',text('preview_note_short')));return box;
  }
  function plural(prefix, count) {
    var form = new Intl.PluralRules(config.locale).select(count);
    return prefix + (form === 'one' ? 'one' : form === 'few' ? 'few' : 'many');
  }
  // Native copy: gaps are projected from quantities, savings only from cart.js.
  function nativeGoalText(goal, projectedGoal) {
    if (goal.kind === 'sachets') {
      if (!goal.reached) return text(plural('native_sachet_gap_', goal.gap), {count:goal.gap, percent:goal.percent});
      if (projectedGoal) return text('native_sachet_pending', {count:goal.target, percent:goal.percent});
      return goal.appliedSavings > 0 ? text('native_sachet_applied', {percent:goal.percent, amount:money(goal.appliedSavings)}) :
        text('native_sachet_reached', {count:goal.current, percent:goal.percent});
    }
    if (!goal.reached) return text('native_bf_gap', {percent:goal.percent, amount:money(goal.gap, true)});
    return goal.appliedSavings > 0 ? text('native_bf_applied', {amount:money(goal.appliedSavings)}) : text('native_bf_reached', {percent:goal.percent});
  }
  function shippingText(shipping, surface, cartEmpty) {
    if (shipping.reached) return text('shipping_reached');
    if (surface === 'pdp' && shipping.mode === 'native-verified') {
      return cartEmpty ? text('shipping_from', {amount:money(shipping.threshold, true)}) : text('shipping_cart_gap', {amount:money(shipping.gap, true)});
    }
    return text('shipping_gap', {amount:money(shipping.gap, true)});
  }
  function cartHasBox() {
    return !!(cart && Array.isArray(cart.items) && cart.items.some(function (line) {
      var v = catalog && catalog.variants[String(line.variant_id || line.id)];
      return line.has_components === true || !!(v && (v.knownBox || v.product.recipe));
    }));
  }
  // PDP shipping line: project the current selection onto the real cart (progress
  // only, never a saving). The projection errs low, so "free" is never claimed early.
  function pdpShipping(shipping, items) {
    if (shipping.reached) return goalNode(shipping, text('shipping_reached'), null);
    var total = null, entries = (items || []).map(function (row) { return {variant:catalog && catalog.variants[String(row.id)], quantity:Number(row.quantity)}; });
    if (entries.length && entries.every(function (e) { return e.variant && Number.isSafeInteger(e.quantity) && e.quantity > 0; })) {
      // Counted before discounts, the selection adds its list price exactly.
      if (shipping.subtotalBasis === 'original_total_price') total = entries.reduce(function (sum, e) { return sum + e.variant.price * e.quantity; }, shipping.subtotal);
      else try { total = engine.projectNativeTotal(cart, catalog, policy(), entries, now()); } catch (_) { total = null; }
    }
    if (!Number.isSafeInteger(total)) {
      return textNode(shippingText(shipping, 'pdp', !cart || !cart.item_count), 'shipping');
    }
    var reached = total >= shipping.threshold;
    var goal = {current:Math.min(total, shipping.threshold), target:shipping.threshold, progress:Math.min(1, total / shipping.threshold), reached:reached};
    var node = goalNode(goal, reached ? text('shipping_with_selection') : text('shipping_selection_gap', {amount:money(shipping.threshold - total, true)}), null);
    if (reached) node.classList.add('is-reached');
    return node;
  }
  // The cart is pending while a change is in flight or no read has confirmed what it must
  // show now (a Black Friday boundary the client clock passed before Shopify did).
  function cartPending() { return !!(win.GRIGCart && (win.GRIGCart.busy || win.GRIGCart.pending === true)); }
  // A saving read from a pending cart is not shown until a read confirms it; the node keeps
  // its place, so nothing below it moves.
  function holdSaving(node) {
    if (cartPending()) node.classList.add('gaov-goal--held');
    return node;
  }
  // A pending cart states a rule neutrally: its name over an empty bar, no gap, nothing reached.
  function pendingGoal(kind, title) {
    var box = el('div','gaov-goal gaov-goal--' + kind + ' gaov-goal--pending'), track = el('div','gaov-track'), fill = el('span');
    track.setAttribute('aria-hidden','true');fill.style.setProperty('--aov-progress','0%');track.append(fill);
    box.dataset.offerGoal = kind;box.append(el('p','gaov-heading',title),track);return box;
  }
  // While the cart is pending, the cart a shipping line was quoted for may not be the one
  // Shopify holds: the line states only the threshold (no gap, nothing reached) over an
  // empty bar until a read confirms the cart.
  function pendingShipping(shipping) {
    return goalNode({current:0, target:shipping.threshold, progress:0}, text('shipping_from', {amount:money(shipping.threshold, true)}), null);
  }
  function renderNative(slot, content, items, projected) {
    var surface = slot.dataset.offerSurface, goal = (projected || state).nextGoal, shown = false;
    var empty = !(cart && cart.item_count), inCart = surface === 'drawer' || surface === 'cart';
    // Browsing pages stay product first, and an empty cart shows no bars at all:
    // progress appears once the cart has something in it.
    if ((surface === 'collection' || surface === 'home' || inCart) && empty) {slot.hidden = true;return;}
    // A PDP selection that does not count (a box) must not advertise the sachet rule.
    if (goal && surface === 'pdp' && goal.kind === 'sachets') {
      var before = state.nextGoal ? state.nextGoal.current : 0;
      if (!projected || goal.current <= before) goal = null;
    }
    // The sachet percentage is promised only without a code in the cart, and a selection
    // never claims the tier while the real cart already holds enough sachets but Shopify
    // allocates nothing under the rule's title (a paused rule, a code preferred).
    var realGoal = state.nextGoal;
    // While Shopify runs Black Friday for this cart the sachet tier is claimed nowhere; a
    // pending cart (a boundary not yet shown) still names the rule neutrally below.
    if (goal && goal.kind === 'sachets' && !(goal.appliedSavings > 0) && !(goal.bfRunning && cartPending())) {
      if (goal.bfRunning) goal = null;
      else if (!goal.reached) {
        // A gap: promised only without a code.
        if (goal.promisable === false) goal = null;
      } else if (projected) {
        // A selection reaching the tier: not with a code, and not while the real cart
        // already holds enough sachets and Shopify allocates nothing under the rule.
        var unallocated = !!(realGoal && realGoal.kind === 'sachets' && realGoal.reached && !(realGoal.appliedSavings > 0));
        if (goal.promisable === false || unallocated) goal = null;
      }
    }
    // The Black Friday gap is promised only while Shopify applies Black Friday to the real
    // cart and no code is in it (the engine's promisable); otherwise there is no claim. A cart
    // that cannot show it yet (no lines) names Black Friday neutrally, without tier or gap.
    if (goal && goal.kind === 'bf' && !goal.reached && goal.promisable === false) {
      if (goal.noEvidence && !cartPending()) {content.append(textNode(text('bf_label'), 'bf'));shown = true;}
      goal = null;
    }
    // A pending cart makes no Black Friday claim at all (its period is not confirmed).
    if (goal && goal.kind === 'bf' && cartPending()) goal = null;
    // In the cart the sachet rule starts with the first eligible sachet; a gift box alone is not nagged.
    if (goal && inCart && goal.kind === 'sachets' && !(goal.current >= 1)) goal = null;
    // A pending cart (a change in flight, or no read confirming it) may not be the one Shopify
    // holds: the sachet rule is named without a gap, a reached tier or a saving.
    if (goal && goal.kind === 'sachets' && cartPending()) {
      content.append(pendingGoal('sachets', text('sachet_label')));shown = true;goal = null;
    }
    // Black Friday: a reached tier is claimed only when Shopify allocates it in the real
    // cart. Otherwise only a saving Shopify applies under a Black Friday title is stated,
    // as plain text without a tier; with no such saving there is no claim at all.
    if (goal && goal.kind === 'bf' && goal.reached && !goal.tierConfirmed) {
      if (projected && realGoal && realGoal.kind === 'bf' && realGoal.tierConfirmed) goal = realGoal;
      else {
        if (realGoal && realGoal.kind === 'bf' && realGoal.appliedSavings > 0) {
          content.append(holdSaving(textNode(text('native_bf_applied', {amount:money(realGoal.appliedSavings)}), 'bf')));shown = true;
        }
        goal = null;
      }
    }
    if (goal) {
      var copy = nativeGoalText(goal, !!projected && goal.kind === 'sachets');
      var exclusion = goal.kind === 'sachets' && surface !== 'pdp' && !goal.reached && cartHasBox() ? text('sachet_exclusion') : null;
      var node = goalNode(goal, copy, exclusion);
      node.dataset.offerGoal = goal.kind;node.classList.add('gaov-goal--' + goal.kind);
      if (goal.reached) node.classList.add('is-reached');
      content.append(goal.appliedSavings > 0 ? holdSaving(node) : node);shown = true;
    }
    var shipping = state.shipping, held = cartPending();
    if (shipping) {
      var ship = held ? pendingShipping(shipping) : surface === 'pdp' ? pdpShipping(shipping, items) : goalNode(shipping, shippingText(shipping, surface, empty), null);
      ship.dataset.offerGoal = 'shipping';ship.classList.add('gaov-goal--shipping');
      if (shipping.reached && !held) ship.classList.add('is-reached');
      content.append(ship);shown = true;
    }
    // The bars add no one-click addition of their own: /cart shows one upsell, its merchandising slot
    // below checkout, and the drawer's suggestions own the drawer's (live audit, P1.2).
    slot.classList.toggle('gaov--native', true);
    slot.hidden = !shown;
  }
  // A decision belongs to the exact cart GRIGCart last published. When that cart is
  // gone (its read-back failed) or another one replaced it, nothing decided for it
  // (reached, applied, gap, projection) may stay on screen: drop it, and cancel any
  // quote still waiting for the catalog, until a cart update quotes the new cart.
  function verifyCart() {
    if (!state || !win.GRIGCart || win.GRIGCart.state === cart) return;
    revision++;state=null;settledState=null;cart=win.GRIGCart.state || null;refreshOpenSummary();
  }
  // An interaction (a selection, a quantity) on the cart GRIGCart holds, with no fresh
  // catalog: quote it again with a fresh one. Event handlers call this, never render().
  function refreshExpired() {
    if (!cart || fresh(catalog) || !win.GRIGCart || win.GRIGCart.state !== cart) return false;
    update(cart);return true;
  }
  // An expired catalog prices nothing more: drop the decision it quoted (no fetch here;
  // the next cart read, selection or open drawer quotes again with a fresh catalog).
  function dropExpired() {
    if (!state || fresh(catalog)) return;
    state=null;renderAll();refreshOpenSummary();
  }
  // Quote the cart GRIGCart holds again with the catalog held here, and draw it at once.
  function requote() {
    try {state=quote(cart,catalog);} catch (_) {state=null;}
    renderAll();refreshOpenSummary();
    if (state) doc.dispatchEvent(new win.CustomEvent('grig:offers-updated',{detail:{state:state,cart:cart,catalog:catalog,scenario:scenario}}));
  }
  // Black Friday starts and ends on its schedule, not at the next interaction, and Shopify's
  // cart changes with it (its automatic discount starts or stops). The client clock may pass
  // the boundary before Shopify's does, so the new period is confirmed from a read itself:
  // after the end no allocation carries a Black Friday title, after the start a cart with
  // lines carries one. Until a read shows that, GRIGCart keeps the cart pending (no line
  // price, total, saving, Black Friday or shipping claim) and reads it again with a bounded
  // backoff; then the drawer's lines, total and summary and the /cart body (through its
  // signature check) show the cart after the boundary. When no read shows it (Shopify keeps
  // or never starts its discount for this cart: a code it prefers, an excluded line, its own
  // schedule), the last read stands after the backoff with Shopify's own prices; a Black
  // Friday gap, tier or saving is still stated only from Shopify's allocation in that read.
  // A title compares as Shopify and the theme setting may each write it: outer spaces and case aside.
  function normTitle(title) { return typeof title === 'string' ? title.trim().toLowerCase() : ''; }
  function bfTitles(bf) { return [bf.base && bf.base.title, bf.bonus && bf.bonus.title].map(normTitle).filter(Boolean); }
  // Every discount application a cart carries (order level and per line), by title and type.
  function applications(value) {
    var rows = [];
    function add(app) { if (app) rows.push({title:normTitle(app.title), type:app.type}); }
    (value.cart_level_discount_applications || []).forEach(add);
    value.items.forEach(function (line) { (line.line_level_discount_allocations || []).forEach(function (a) { add(a && a.discount_application); }); });
    return rows;
  }
  // The start shows on a cart that can carry Black Friday (it has lines, in the rule's
  // currency) as an application under one of its titles; a cart that cannot (empty, another
  // currency) shows the start as it is. The end needs positive evidence: nothing under a Black
  // Friday title, and every other application a code or a rule the theme knows (the sachet
  // rule). An unknown automatic discount may be Black Friday renamed: the wait goes on, bounded.
  function periodConfirmed(bf, started, known) {
    var titles = bfTitles(bf);
    return function (value) {
      if (!value || !Array.isArray(value.items)) return false;
      var apps = applications(value), carries = apps.some(function (a) { return titles.indexOf(a.title) >= 0; });
      if (started) return !value.items.length || value.currency !== bf.currency || carries;
      return !carries && apps.every(function (a) { return a.type === 'discount_code' || known.indexOf(a.title) >= 0; });
    };
  }
  // Without usable titles nothing can show the new period: the cart is only read again on the
  // same backoff, never held (no Black Friday rule quotes anything without its titles).
  var REREADS = [1000, 3000, 10000, 30000, 60000], rereadTimer = 0;
  function reread(step) {
    win.clearTimeout(rereadTimer);
    if (win.GRIGCart && !win.GRIGCart.busy && typeof win.refreshCart === 'function') win.refreshCart();
    if (step < REREADS.length) rereadTimer = win.setTimeout(function () { reread(step + 1); }, REREADS[step]);
  }
  // The boundary is kept on Shopify's clock (now()): it is checked when its time comes and on
  // every cart read, which may show Shopify's clock past a boundary the client's has not
  // reached. Entering a later period (before, during, after) starts the boundary; a clock
  // found ahead of Shopify's only moves the period back, as the read it came with is Shopify's.
  // Plain mode has no native Black Friday rule and schedules no boundary: its legacy campaign
  // keeps its own schedule in the merchandising script.
  var boundaryTimer = 0, period = null;
  // The dates are the engine's (engine.bfDates: zoned, the end after the start), and only a
  // rule the engine quotes (engine.bfSchedule) holds the cart at a boundary; any other is only
  // read again.
  function scheduleBoundary() {
    win.clearTimeout(boundaryTimer);
    var native = nativeConfig(), bf = native && native.bf, dates = bf && engine.bfDates(bf);
    if (!dates) return;
    var start = dates.start, end = dates.end, at = now();
    var current = at < start ? 0 : at < end ? 1 : 2;
    // The first answered cart read sets the period the page is in, never passing a boundary:
    // only a boundary crossed while the page is open waits for a read to show it.
    if (!clockKnown()) period = null;
    else {
      if (period !== null && current > period) boundaryPassed(native, bf, current === 1);
      period = current;
    }
    var next = [start, end].filter(function (time) { return time > at; }).sort(function (a, b) { return a - b; })[0];
    if (next) boundaryTimer = win.setTimeout(scheduleBoundary, Math.min(next - at + 20, 2147483647));
  }
  function boundaryPassed(native, bf, started) {
    var expect = win.GRIGCart && typeof win.GRIGCart.expect === 'function' && !!engine.bfSchedule(native) && bfTitles(bf).length > 0;
    var known = [normTitle(native.sachets && native.sachets.title)].filter(Boolean);
    if (expect) win.GRIGCart.expect(periodConfirmed(bf, started, known));
    if (state && cart && fresh(catalog)) requote();
    else if (state) {state=null;renderAll();refreshOpenSummary();}
    if (!expect) reread(0);
  }
  // Rendering only draws: a decision whose catalog has expired draws nothing (the
  // refresh belongs to the timers and events, so render() never touches the network).
  // A slot is built apart and drawn only where it differs (GRIGMerch.redraw), so a refresh
  // that decides the same never moves keyboard focus.
  function render(slot) {
    verifyCart();
    var content = slot.querySelector('[data-offer-content]');
    if (!state || !fresh(catalog)) {slot.hidden=true;if(content)win.GRIGMerch.redraw(content,[],null);return;}
    if (!content) return;
    var draft = doc.createElement('div');
    draw(slot, draft);
    win.GRIGMerch.redraw(content, Array.from(draft.children), slot.querySelector('[data-offer-status]'));
  }
  function draw(slot, content) {
    var items = pending.get(slot), projected = items && items.length ? projectionFor(items) : null;
    var result = projected || state;
    if (state.mode === 'native') return renderNative(slot, content, items, projected);
    var goal = result.nextGoal;
    if (items && items.length && (goal || result.shipping)) content.append(el('p','gaov-note',text(projected ? 'pending' : 'unavailable')));
    if (goal) {
      var key = goal.kind === 'sachets' ? (goal.reached ? 'sachet_reached' : 'sachet_gap') : (goal.reached ? 'bf_reached' : 'bf_gap');
      if(key==='sachet_gap') {var plural=new Intl.PluralRules(config.locale).select(goal.gap);if(plural==='one'||plural==='few')key+='_'+plural;}
      content.append(goalNode(goal,text(key,{count:goal.gap,percent:goal.percent,amount:money(goal.gap)}),
        goal.kind === 'sachets' ? text('sachet_exclusion') : null));
    }
    // A plain PDP selection has no projected shipping; show the real cart line instead.
    var plainShip = !result.shipping && state.mode === 'plain' && slot.dataset.offerSurface === 'pdp' ? state.shipping : null;
    if (result.shipping) content.append(cartPending() ? pendingShipping(result.shipping) : goalNode(result.shipping,
      text(result.shipping.reached ? 'shipping_reached' : 'shipping_gap',{amount:money(result.shipping.gap)}),
      result.shipping.mode === 'preview' && result.shipping.planned ? text('planned_shipping') : null));
    else if (plainShip) {
      var plainNode = cartPending() ? pendingShipping(plainShip) : goalNode(plainShip, shippingText(plainShip, 'pdp', !cart || !cart.item_count), null);
      plainNode.dataset.offerGoal = 'shipping';content.append(plainNode);
    }
    var detailed = ['drawer','cart'].includes(slot.dataset.offerSurface);
    if (authorized() && detailed) content.append(totals(result));
    if (authorized() && !goal && scenario === 'bf' && result.currency === 'CZK') content.append(el('p','gaov-note',text('bf_unavailable')));
    var next = !(items && items.length) && result.opportunities.find(function (o) { return o.kind === 'add-sachet'; });
    if (next && catalog.variants[next.variantId]) {
      var v = catalog.variants[next.variantId], title = v.product.title + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
      var button = el('button','gaov-add',text('add_one',{product:title,amount:money(next.price)}));
      button.type='button';button.dataset.offerAdd=next.variantId;button.dataset.offerPrice=String(next.price);
      button.disabled=localBusy || cartPending();content.append(button);
    }
    slot.hidden = !content.children.length;
  }
  function renderAll() {
    verifyCart();slots.forEach(render);updateBanner();
    // Native mode owns all shipping copy: only the explicit per-country amount may be
    // shown. Ownership follows the native settings, not the current quote, so the
    // legacy threshold copy never returns while a quote is dropped or reloading.
    var native=!!nativeConfig();
    function owned(surface){
      return (native && slots.some(function(slot){return slot.dataset.offerSurface===surface;})) ||
        (!!state && !!state.shipping && slots.some(function(slot){return slot.dataset.offerSurface===surface && !slot.hidden;}));
    }
    var drawer=doc.getElementById('drawer');
    if(drawer)drawer.classList.toggle('gaov-shipping-owned',owned('drawer'));
    ['cart','pdp'].forEach(function(surface){doc.body.classList.toggle('gaov-'+surface+'-shipping-owned',owned(surface));});
    doc.querySelectorAll('[data-aov-preview-checkout]').forEach(function (button) { button.disabled = !authorized() || !state || localBusy || !!(win.GRIGCart && win.GRIGCart.busy); });
  }
  function goalTransitions(before, after) {
    engine.goalTransitions(before, after).forEach(function(change){
      var goal=change.goal;
      doc.dispatchEvent(new win.CustomEvent('grig:offer-interaction',{detail:{event:change.event,
        surface:'cart',kind:goal.kind,variantIds:[],quantities:[],valueCents:goal.kind==='sachets'?0:goal.target,
        threshold:goal.target,thresholdUnit:goal.kind==='sachets'?'sachets':'cents',currency:after.currency}}));
    });
  }
  async function update(value) {
    if (!value || !Array.isArray(value.items)) return;
    // The read may have shown Shopify's clock past a boundary.
    scheduleBoundary();
    var current = ++revision, before=settledState;
    // A quote belongs to one exact cart revision. Invalidate synchronously before
    // awaiting the shared catalog: nothing decided for an earlier cart (reached,
    // applied, gap) may be rendered for this one. Native mode re-quotes the new cart
    // at once with the catalog it already holds, so its bars stay in place without a
    // flash; a cart in another currency, or without a fresh held catalog that resolves
    // every line, shows nothing until the new quote lands.
    var requote = !!(state && state.mode === 'native' && catalog && state.currency === (value.currency || null) && catalogCovers(catalog, value));
    cart=value;state=null;
    if (requote) {try {state=quote(cart,catalog);} catch (_) {state=null;}}
    else catalog=null;
    renderAll();refreshOpenSummary();
    try {
      var data = await getCatalog(false); if (current !== revision) return;
      catalog=data;state=quote(cart,catalog);renderAll();refreshOpenSummary();goalTransitions(before,state);settledState=state;
      doc.dispatchEvent(new win.CustomEvent('grig:offers-updated',{detail:{state:state,cart:cart,catalog:catalog,scenario:scenario}}));
    } catch (_) {
      if(current!==revision)return;
      state=null;catalog=null;settledState=null;renderAll();refreshOpenSummary();
    }
  }
  function updateBanner() {
    if (!banner) return;banner.hidden=!authorized();
    banner.querySelectorAll('[data-offer-scenario]').forEach(function (button) { button.setAttribute('aria-pressed',String(button.dataset.offerScenario===scenario)); });
    banner.querySelector('[data-offer-preview-note]').textContent=text(scenario==='bf' ? 'bf_period' : 'preview_note');
    previewLayout();
  }
  function previewLayout() {
    var visible=!!(banner && !banner.hidden && authorized());
    doc.body.classList.toggle('gaov-preview-active',visible);
    doc.body.style.setProperty('--grig-offer-preview-height',(visible?Math.ceil(banner.getBoundingClientRect().height):0)+'px');
  }
  function makeBanner() {
    if (!authorized()) {previewLayout();return;}
    banner=el('aside','gaov-preview');banner.setAttribute('aria-label',text('preview'));
    var copy=el('div','gaov-preview-copy');copy.append(el('strong','',text('preview')));
    var note=el('p');note.dataset.offerPreviewNote='';copy.append(note);var controls=el('div','gaov-preview-controls');
    ['regular','bf'].forEach(function (name) {var button=el('button','',text(name));button.type='button';button.dataset.offerScenario=name;controls.append(button);});
    banner.append(copy,controls);doc.body.prepend(banner);updateBanner();
    if(win.ResizeObserver)new win.ResizeObserver(previewLayout).observe(banner);
    win.addEventListener('resize',previewLayout,{passive:true});
  }
  // Keyboard focus is moved only onto what the shopper sees: the target is scrolled into view.
  function focusInView(node) {
    function show() { if (doc.activeElement === node) { try { node.scrollIntoView({block:'nearest', inline:'nearest'}); } catch (_) { /* Focus is a courtesy. */ } } }
    try { node.focus({preventScroll:true}); } catch (_) { return; }
    show(); win.requestAnimationFrame(show);
  }
  function closeSummary() { if (dialog && dialog.open) dialog.close(); if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true}); }
  function refreshOpenSummary() {
    if(!dialog || !dialog.open)return;
    var old=dialog.querySelector('.gaov-totals');
    // Preserve the focused close button while removing every obsolete quote.
    if(old)old.replaceWith(totals(state));
  }
  function summary(trigger) {
    if (!authorized() || !state) return;
    // Focus goes back only to the checkout control that opened it, never to a cart control.
    returnFocus=trigger || null;
    if (!dialog) {
      dialog=el('dialog','gaov-dialog');dialog.setAttribute('aria-labelledby','grig-offer-summary-title');
      dialog.addEventListener('cancel',function (event) { event.preventDefault();closeSummary(); });
      dialog.addEventListener('keydown',function (event) {
        if(event.key!=='Tab')return;
        var focusable=Array.from(dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),[tabindex="0"]'))
          .filter(function(n){return n.getClientRects().length;});
        var first=focusable[0],last=focusable[focusable.length-1];
        if(first && ((event.shiftKey && doc.activeElement===first)||(!event.shiftKey && doc.activeElement===last))) {
          event.preventDefault();(event.shiftKey?last:first).focus();
        }
      });
      dialog.addEventListener('click',function (event) { if (event.target===dialog) {var rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeSummary();} });
      doc.body.append(dialog);
    }
    dialog.replaceChildren();var title=el('h2','',text('summary'));title.id='grig-offer-summary-title';
    dialog.append(title,el('p','',text('summary_note')),totals(state));
    var close=el('button','gaov-add',text('close'));close.type='button';close.addEventListener('click',closeSummary);dialog.append(close);
    if (!dialog.open) dialog.showModal();close.focus();
  }
  function checkoutURL(value) { try {return /\/(?:checkout|checkouts)(?:\/|$)/.test(new URL(value,win.location.href).pathname);} catch (_) {return false;} }
  doc.addEventListener('click',function (event) {
    if (!authorized()) return;
    var target=event.target.closest('[data-aov-preview-checkout],a[href],button[name="checkout"],input[name="checkout"]');
    if (target && (target.hasAttribute('data-aov-preview-checkout') || target.name==='checkout' || checkoutURL(target.href))) {
      event.preventDefault();event.stopImmediatePropagation();summary(target);
    }
  },true);
  doc.addEventListener('submit',function (event) {
    if (!authorized()) return;
    if (checkoutURL(event.target.action) || (event.submitter && (event.submitter.name==='checkout' || event.submitter.hasAttribute('data-aov-preview-checkout')))) {
      event.preventDefault();event.stopImmediatePropagation();summary(event.submitter);
    }
  },true);
  doc.addEventListener('click',async function (event) {
    var toggle=event.target.closest('[data-offer-scenario]');
    if (toggle && authorized()) {scenario=toggle.dataset.offerScenario;await update(cart);return;}
    var button=event.target.closest('[data-offer-add]');
    // Nothing is added to a cart no read has confirmed: a change in flight, a write that may
    // still land (it could add the goods twice), a period boundary.
    if (!button || localBusy || !state || !cart || !win.GRIGCart || cartPending()) return;
    var slot=button.closest('[data-grig-offer]'), status=slot.querySelector('[data-offer-status]'), error=slot.querySelector('[data-offer-error]');
    var variantId=button.dataset.offerAdd, expectedPrice=Number(button.dataset.offerPrice);
    localBusy=true;error.hidden=true;status.textContent='';renderAll();
    try {
      var result=await win.GRIGCart.addItems([{id:variantId,quantity:1}],{source:'offer_progress',button:button,
        validate:async function (latest) {
          var data=await getCatalog(true), v=data.variants[variantId], current=quote(latest,data);
          if (!v || v.price!==expectedPrice || !engine.projectAdding(latest,v,1) ||
              !current.opportunities.some(function (o) {return o.kind==='add-sachet' && o.variantId===variantId;})) throw new Error('offer_changed');
        }});
      // An addition whose outcome is unknown is neither: the drawer says the cart is being checked.
      if (result && result.unknown === true) status.textContent='';
      else {
        if (!result || !result.ok) throw new Error('add_failed');
        if (result.cart) await update(result.cart);status.textContent=text('added');focusInView(status);
      }
    } catch (_) {error.textContent=text('changed');error.hidden=false;error.tabIndex=-1;focusInView(error);}
    finally {localBusy=false;renderAll();}
  });
  doc.addEventListener('grig:cart-updated',function (event) {update(event.detail && event.detail.cart);});
  doc.addEventListener('grig:cart-busy',renderAll);
  doc.addEventListener('grig:cart-pending',renderAll);
  doc.addEventListener('grig:cart-load-error',renderAll);
  doc.addEventListener('grig:catalog-expired',dropExpired);
  // A newly loaded catalog re-quotes the cart GRIGCart holds at once, so a refresh before
  // expiry replaces the decision in place (no blank, no flicker).
  doc.addEventListener('grig:catalog-loaded',function (event) {
    var data = event.detail && event.detail.catalog;
    if (!cart || !win.GRIGCart || win.GRIGCart.state !== cart || !catalogCovers(data, cart)) return;
    catalog=data;requote();
  });
  doc.addEventListener('grig:cart-open',dropExpired);
  doc.addEventListener('grig:offer-preview-change',function (event) {
    var detail=event.detail || {};if (!slots.includes(detail.surface) || !Array.isArray(detail.items)) return;
    pending.set(detail.surface,detail.items);if (!refreshExpired()) render(detail.surface);
  });
  function readPDP() {
    slots.filter(function (slot) {return slot.dataset.offerSurface==='pdp';}).forEach(function (slot) {
      var form=slot.dataset.offerForm && doc.getElementById(slot.dataset.offerForm) || doc.getElementById('grig-pdp-form');
      if (!form) return;var idInput=form.elements.namedItem('id'), qtyInput=form.elements.namedItem('quantity');
      if (idInput) {pending.set(slot,[{id:idInput.value,quantity:Number(qtyInput ? qtyInput.value : 1)}]);if (!refreshExpired()) render(slot);}
    });
  }
  doc.addEventListener('change',readPDP);doc.addEventListener('input',readPDP);
  // Shopify's total after hypothetical changes, modelled by the native engine; null
  // outside native mode or whenever the cart carries a discount it cannot model.
  function projectNative(value, data, entries, removals) {
    return engine.projectNativeTotal(value, data || catalog, policy(), entries, now(), removals);
  }
  win.GRIGOffers={quote:quote,getState:function () {return state && fresh(catalog) ? state : null;},getCatalog:getCatalog,projectionFor:projectionFor,projectNative:projectNative,
    policy:policy,native:function () {return !!nativeConfig();},preview:authorized,text:text,money:money,renderAll:renderAll};
  // Shipping ownership applies from the start, before the first cart read answers (or
  // when it never does): native mode never lets the legacy threshold copy show.
  makeBanner();readPDP();renderAll();scheduleBoundary();
  if (win.GRIGCart && win.GRIGCart.state) update(win.GRIGCart.state);
  // grig.js already performs its one bootstrap refresh. Wait for its native event.
})(window);
